import React from 'react';
import StandardTable, {
  DEFAULT_ROWS_PER_PAGE_OPTIONS,
} from 'toolkit/tables/standard-table';
import { HeaderCellConfig } from 'toolkit/tables/types/header.types';
import { MenuItemConfig } from 'toolkit/tables/types/menu.types';
import { PaginationBounds } from 'toolkit/tables/types/table.types';
import styled from 'styled-components';

const ScrollableTableWrapper = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Override StandardTableContainer styles to enable scrolling */
  & > div:first-child {
    overflow: hidden !important;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  /* Override StandardTableContainer styles to enable scrolling */
  & .MuiTableContainer-root {
    overflow-y: auto !important;
    overflow-x: auto !important;
    flex: 1;
    min-height: 0;
    padding-bottom: 0 !important;
  }

  /* Make pagination truly sticky to container bottom */
  & .MuiTablePagination-root {
    position: sticky !important;
    right: 0 !important;
    bottom: 0 !important;
    background-color: white !important;
    border-top: 1px solid #e0e0e0 !important;
    margin-top: 0 !important;
    flex-shrink: 0 !important;
    z-index: 1 !important;
  }
`;

interface ScrollableTableProps<T, V extends string> {
  data: T[];
  dataRowElement: React.FunctionComponent<{
    data: T;
    openAdditionalMenu: (event: React.MouseEvent<HTMLElement>, data: T) => void;
  }>;
  headerCells: HeaderCellConfig<V>[];
  totalRecords: number;
  menuItems?: MenuItemConfig<T>[];
  bounds: PaginationBounds;
  dispatchAction: (params: any) => void;
  setBounds: React.Dispatch<React.SetStateAction<PaginationBounds>>;
  stickyHeader?: boolean;
  rowKeyGenerator?: (entry: T) => string;
  isLoading?: boolean;
}

const ScrollableTable = <T, V extends string>(
  props: ScrollableTableProps<T, V>
) => {
  return (
    <ScrollableTableWrapper>
      <StandardTable {...props} />
    </ScrollableTableWrapper>
  );
};

export default ScrollableTable;
export { DEFAULT_ROWS_PER_PAGE_OPTIONS };
